import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MessageService, MobileCountryInfo } from '../../message.Service';
import { TranslateService } from '@ngx-translate/core';
import { NetworkService } from '../../network.Service';
import { Organization, AuthenticationService, OrganizationModel } from "../../authentication.Service";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MediaService } from '../../media.Service';
import { MessageModel } from "../../message.Service";
import { SmsEditorComponent } from '../../Development/sms-editor/sms-editor.component';

class OrgList {
  selected: boolean;
  icon: string;
  name: string;
  email: string;
  value: number;
  memberId: number;
  mediaId: number;
  mediaService: MediaService;

  constructor(selected: boolean, icon: string, name: string, email: string, value: number, memberId: number, mediaId: number,
    mediaService: MediaService) {
    this.selected = selected;
    this.icon = icon;
    this.name = name;
    this.email = email;
    this.value = value;
    this.memberId = memberId;
    this.mediaId = mediaId;
    this.mediaService = mediaService;
  }

  get media() {
    if (this._media != null) {
      return this._media == "" ? null : this._media;
    }

    if (this.mediaId == 0) {
      this._media = "";
      return null;
    }

    this.mediaService.getMediaById(this.mediaId).subscribe(
      result => {
        this._media = result;
      },
      error => {
        this._media = "";
      });
  }
  private _media = null;
}

@Component({
  selector: 'app-dlc-brand',
  templateUrl: './dlc-brand.component.html',
  styleUrl: './dlc-brand.component.css'
})
export class DlcBrandComponent {
  formGroup: FormGroup;
  errorMsg: string;
  displayError: boolean;
  displaySuccess: boolean;
  dataReady: boolean = false;
  countrycode: number = 0;
  countries: MobileCountryInfo[] = [];
  isAdminView = false;
  isMemberView = true;
  tempOrgs?: Observable<Organization[]>;
  orgPageSize: number = 20;
  userId: number = 0;
  organizations: Organization[] = [];
  orgList: OrgList[] = [];
  selectedOrg?: OrgList;
  ownOrganizations: boolean = false;
  message: string = "";

  @ViewChild('sms') public sms: SmsEditorComponent | undefined;

  constructor(private fb: FormBuilder,
    public translate: TranslateService,
    private authService: AuthenticationService,
    private messageService: MessageService,
    private networkSerivce: NetworkService,
    private mediaService: MediaService
  ) {
    this.errorMsg = "";
    this.displayError = false;
    this.displaySuccess = false;
    this.messageService.getCountries().subscribe(result => {
      this.countries = result;
      this.orgList = [];
      this.checkOrg();
    });

    this.formGroup = new FormGroup({
      category: new FormControl(),
      Type: new FormControl("sms"),
      Organization: new FormControl(),
      companyname: new FormControl(),
      brandname: new FormControl(),
      taxNumber: new FormControl(),
      website: new FormControl(),
      verticaltype: new FormControl(),
      Country: new FormControl(),
      postalcode: new FormControl(),
      address: new FormControl(),
      city: new FormControl(),
      state: new FormControl(),
      email: new FormControl(),
      phonenumber: new FormControl(),
      usecase: new FormControl(),
      campaignname: new FormControl(),
      campaigndescription: new FormControl(),
      samplemessage: new FormControl(),
      suboptinflow: new FormControl(),
      messageboxin: new FormControl(),
      suboptoutflow: new FormControl(),
      messageboxout: new FormControl(),
      suboptinflowhelp: new FormControl(),
      messageboxhelp: new FormControl(),
      descriptionhelp: new FormControl(),
      descriptionoptout: new FormControl(),
      descriptionoptin: new FormControl()
    });
  }

  isSms(): boolean {
    return this.formGroup.controls.Type.value == "sms";
  }

  checkOrg() {
    let userId = this.authService.getUserId();

    this.authService.getOrganizationSummariesForMember().subscribe(result => {
      /*let m = this.orgList[0];
      m.selected = false;*/
      this.orgList = [];
      this.organizations = result;
      //this.orgList.push(m);
      let i = this.authService.currentOrganization();
      let found = false;
      /*for (let j = 0; j < this.organizations.length; j++) {
        let org = this.organizations[j];
        let o = new OrgList(false, org.OrganizationId == i ? 'supervised_user_circle' : 'supervisor_account', org.Name, "", org.OrganizationId, org.MemberId, org.MediaId, this.mediaService);
        if (org.RoleId == 5) {
          this.ownOrganizations = true;
        }

        if (o.value == i) {
          found = true;
          this.selectedOrg = o;
        }
        else {
          this.orgList.push(o);
        }
      }*/
    });
  }

  newSearch() {
    this.networkSerivce.dlcbrandregrequest(this.formGroup.value.Organization?.name, this.formGroup.value.category, this.formGroup.value.companyname,
      this.formGroup.value.brandname, this.formGroup.value.taxNumber, this.formGroup.value.website,
      this.formGroup.value.verticaltype, this.formGroup.value.Country?.Country, this.formGroup.value.postalcode,
      this.formGroup.value.address, this.formGroup.value.city, this.formGroup.value.state,
      this.formGroup.value.email, this.formGroup.value.phonenumber, this.formGroup.value.usecase, this.formGroup.value.campaignname,
      this.formGroup.value.campaigndescription, this.sms?.text ?? "", this.formGroup.value.descriptionoptin,
      this.formGroup.value.messageboxin, this.formGroup.value.descriptionoptout, this.formGroup.value.messageboxout,
      this.formGroup.value.descriptionhelp, this.formGroup.value.messageboxhelp)
      .subscribe(result => {
        this.displayError = false;
        this.displaySuccess = true;
      },
        error => {
          console.error(error);
          this.errorMsg = "There was a problem Sending your DLC_Brand Registration Request. Please Try again later.";
          this.displayError = true;
        });
  }
}

